import React, { useState, useEffect } from "react";
import { FilePond, registerPlugin } from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import '../../css/LeaveRequestForm.css';
import { useTranslation } from 'react-i18next';
import { error } from "jquery";
import { faL } from "@fortawesome/free-solid-svg-icons";
import { isMobile } from 'react-device-detect';
import DateInput from '../common/DateInput';

registerPlugin(FilePondPluginImagePreview, FilePondPluginFileValidateType, FilePondPluginFileValidateSize);
const loadingGif = process.env.REACT_APP_PUBLIC_URL + '/loading1.gif';

function LeaveRequestForm({ language, leaveRequestData, isFormDisabled: isFormDisabledProp, onSendMessage, username, password, employeeID }) {
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    leaveType: leaveRequestData.leaveType,
    fromDate: leaveRequestData.startDate,
    toDate: leaveRequestData.endDate,
    notes: leaveRequestData.reason,
    attachments: [],
    department: "",
    employee: "",
    approver: { "Name": t("Loading...") },
    hospital_type: leaveRequestData.hospital_type || "",
    hospital_name: leaveRequestData.hospital_name || "",
    hospital_location: leaveRequestData.hospital_location === "199", // inside qatar
  });

  const [errors, setErrors] = useState({});
  const [responseMessage, setResponseMessage] = useState("");
  const [isFormDisabled, setIsFormDisabled] = useState(isFormDisabledProp);
  const [isLoading, setIsLoading] = useState(false);
  const [isFormLoading, setIsFormLoading] = useState(true);
  const [showSubstitution, setShowSubstitution] = useState(false);
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [attachmentNames, setAttachmentNames] = useState([]);
  const [attachmentFilesTypes, setAttachmentFilesTypes] = useState([
    "application/pdf",
    "image/jpeg",
    "image/tiff",
    "image/gif",
    "image/jpeg",
    "image/tiff"
  ]);
  const [numOfDays, setNumOfDays] = useState(0);
  const [isErrorMessage, setIsErrorMessage] = useState(false);
  const [substitutions, setSubstitutions] = useState([]);
  const [departments, setDepartments] = useState([]); // Updated to plural to hold multiple departments
  const [hospitalTypes, setHospitalTypes] = useState([]); // New state for hospital types
  const [csrfToken, setCSRFToken] = useState("");
  const [subCSRFToken, setSubCSRFToken] = useState("");
  const [subCookies, setSubCookies] = useState("");
  const [cookies, setCookies] = useState("");
  const [isManager, setIsManager] = useState(false);
  const [loadingCounter, setLoadingCounter] = useState(5); // Start with the number of async operations
  const [validFiles, setValidFiles] = useState(true);
  const [childDetails, setChildDetails] = useState([]);
  const [selectedChild, setSelectedChild] = useState("");
  const [childBirthDate, setChildBirthDate] = useState("");
  const [relativeDegrees, setRelativeDegrees] = useState([]);
  const [selectedRelativeDegree, setSelectedRelativeDegree] = useState(null);


  const decrementLoadingCounter = () => {
    setLoadingCounter(prevCount => {
      const newCount = prevCount - 1;
      if (newCount === 0) {
        setIsFormLoading(false);  // Only set loading to false when all async operations are done
      }
      return newCount;
    });
  };

  function convertToCookieString(jsonObject) {
    const cookieArray = [];
    for (const [key, value] of Object.entries(jsonObject)) {
      cookieArray.push(`${key}=${value}`);
    }
    return cookieArray.join('; ');
  }
  const fetchChildDetails = async () => {
    try {
      let frontendLog = JSON.stringify({ "sessionID": localStorage.getItem('sessionID'), "EmployeeID": localStorage.getItem('EmployeeID'), "channel": isMobile ? "Mobile" : "Portal", "language": localStorage.getItem('language') });
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/middleware/getChildDetails?code=${process.env.REACT_APP_MIDDLEWARE_FUNCTION_KEY}&EmployeeID=${encodeURIComponent(localStorage.getItem('EmployeeID'))}&token=${encodeURIComponent(localStorage.getItem('id_token'))}&sessionID=${encodeURIComponent(localStorage.getItem('sessionID'))}&frontendLog=${encodeURIComponent(frontendLog)}&language=${encodeURIComponent(localStorage.getItem('language'))}`);
      if (!response.ok) throw new Error('Network response was not ok');
      const data = await response.json();
      setChildDetails(data);
    } catch (error) {
      console.error("Error fetching child details:", error);
    }
  };
  const fetchRelativeDegrees = async () => {
    try {
      let frontendLog = JSON.stringify({
        sessionID: localStorage.getItem('sessionID'),
        EmployeeID: localStorage.getItem('EmployeeID'),
        channel: isMobile ? "Mobile" : "Portal",
        language: localStorage.getItem('language')
      });
  
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/middleware/getRelativeDegrees?code=${process.env.REACT_APP_MIDDLEWARE_FUNCTION_KEY}&EmployeeID=${encodeURIComponent(localStorage.getItem('EmployeeID'))}&token=${encodeURIComponent(localStorage.getItem('id_token'))}&sessionID=${encodeURIComponent(localStorage.getItem('sessionID'))}&frontendLog=${encodeURIComponent(frontendLog)}&language=${encodeURIComponent(localStorage.getItem('language'))}`
      );
  
      if (!response.ok) throw new Error("Network response was not ok");
      const data = await response.json();
      setRelativeDegrees(data);
    } catch (error) {
      console.error("Error fetching relative degrees:", error);
    }
  };
 

  // get CSRF token and Cookies
  useEffect(() => {
    const fetchData = async () => {
      try {
        let frontendLog = JSON.stringify({ "sessionID": sessionStorage.getItem('sessionID'), "EmployeeID": localStorage.getItem('EmployeeID'), "channel": isMobile ? "Mobile" : "Portal", "language": localStorage.getItem('language') })
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/middleware/getCurrentEmployee?code=${process.env.REACT_APP_MIDDLEWARE_FUNCTION_KEY}&token=${encodeURIComponent(localStorage.getItem('id_token'))}&sessionID=${encodeURIComponent(sessionStorage.getItem('sessionID'))}&frontendLog=${encodeURIComponent(frontendLog)}`);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const result = await response.json();
        localStorage.setItem("EmployeeID", result.EmployeeID);
        localStorage.setItem("IsManager", result.IsManager);
        setIsManager(result.IsManager == "true" ? true : false);
        fetchDepartments(result.EmployeeID);
      } catch (error) {
        console.error(error);
      } finally {
        decrementLoadingCounter()
      }
    };

    const fetchDepartments = async (currentEmployeeID) => {
      try {
        let frontendLog = JSON.stringify({ "sessionID": sessionStorage.getItem('sessionID'), "EmployeeID": localStorage.getItem('EmployeeID'), "channel": isMobile ? "Mobile" : "Portal", "language": localStorage.getItem('language') })
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/middleware/getDepartment?code=${process.env.REACT_APP_MIDDLEWARE_FUNCTION_KEY}&EmployeeID=${encodeURIComponent(currentEmployeeID)}&token=${encodeURIComponent(localStorage.getItem('id_token'))}&language=${encodeURIComponent(language)}&sessionID=${encodeURIComponent(sessionStorage.getItem('sessionID'))}&frontendLog=${encodeURIComponent(frontendLog)}`);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setDepartments(data.data);
        setSubCSRFToken(data.csrfToken);
        setSubCookies(convertToCookieString(data.cookies));
        fetchEmployeesInDepartment(data.data[0].Department)
      } catch (error) {
        console.error('Error fetching departments:', error);
      } finally {
        decrementLoadingCounter()
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    setIsFormDisabled(isFormDisabledProp);
  }, [isFormDisabledProp]);

  useEffect(() => {
    checkDateDifference(formData.fromDate, formData.toDate);
  }, [formData.fromDate, formData.toDate]);

  useEffect(() => {
    // Fetch leave types when the component mounts
    const fetchLeaveTypes = async () => {
      try {
        let frontendLog = JSON.stringify({ "sessionID": sessionStorage.getItem('sessionID'), "EmployeeID": localStorage.getItem('EmployeeID'), "channel": isMobile ? "Mobile" : "Portal", "language": localStorage.getItem('language') })
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/middleware/getAllLeaveTypes?code=${process.env.REACT_APP_MIDDLEWARE_FUNCTION_KEY}&token=${encodeURIComponent(localStorage.getItem('id_token'))}&language=${encodeURIComponent(language)}&EmployeeID=${encodeURIComponent(localStorage.getItem('EmployeeID'))}&sessionID=${encodeURIComponent(sessionStorage.getItem('sessionID'))}&frontendLog=${encodeURIComponent(frontendLog)}`);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setLeaveTypes(data);
        setCSRFToken(data[0].csrfToken);
        setCookies(convertToCookieString(data[0].cookies));
        // Check if the initial leave type has attachments and update state
        const initialLeaveType = data.find(type => type.AbsenceTypeCode === leaveRequestData.leaveType);
        if (initialLeaveType && initialLeaveType.Attachments) {
          updateAttachmentNames(initialLeaveType);
        }
        setFormData(prevFormData => ({
          ...prevFormData,
          approver: initialLeaveType?.Approver ? initialLeaveType?.Approver : ""
        }));
      } catch (error) {
        console.error('Error fetching leave types:', error);
      } finally {
        decrementLoadingCounter()
      }
    };

    fetchLeaveTypes();
  }, [employeeID]);

  useEffect(() => {
    // Fetch hospital types when the component mounts
    const fetchHospitalTypes = async () => {
      try {
        let frontendLog = JSON.stringify({ "sessionID": sessionStorage.getItem('sessionID'), "EmployeeID": localStorage.getItem('EmployeeID'), "channel": isMobile ? "Mobile" : "Portal", "language": localStorage.getItem('language') })
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/middleware/getHospitalList?code=${process.env.REACT_APP_MIDDLEWARE_FUNCTION_KEY}&assertion=${encodeURIComponent(localStorage.getItem('id_token'))}&language=${encodeURIComponent(language)}&sessionID=${encodeURIComponent(sessionStorage.getItem('sessionID'))}&frontendLog=${encodeURIComponent(frontendLog)}`);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setHospitalTypes(data);
      } catch (error) {
        console.error('Error fetching hospital types:', error);
      } finally {
        decrementLoadingCounter()
      }
    };

    fetchHospitalTypes();
  }, []);

  const handleFilePondUpdate = (fileItems) => {
    const files = fileItems.map(fileItem => fileItem.file);

    // Check if all files are of accepted types
    const allValid = files.every(file => attachmentFilesTypes.includes(file.type));
    setValidFiles(allValid);

    setFormData((prevFormData) => ({
      ...prevFormData,
      attachments: files
    }));

    // Set error if any invalid file is uploaded
    if (!allValid) {
      setErrors(prevErrors => ({
        ...prevErrors,
        attachments: t("One or more files are not in the correct format.")
      }));
    } else {
      setErrors(prevErrors => ({ ...prevErrors, attachments: "" }));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
      
    if (name === 'leaveType') {
      // Child accompany leave
      if (value === "0367") {
        fetchChildDetails();
      } else {
        setChildDetails([]);
        setSelectedChild(""); // reset when leaveType changes
      }
      // Peternity leave
      if (value !== "0335") {
        setChildBirthDate("");
      }
      // Accompany patient leave
      if (value === "0260") {
        fetchRelativeDegrees();
      } else {
        setRelativeDegrees([]);
        setSelectedRelativeDegree("");
      }
      const selectedLeaveType = leaveTypes.find(type => type.AbsenceTypeCode === value);
      if (selectedLeaveType) {
        updateAttachmentNames(selectedLeaveType);
      }
      validate();
    } else if (name === 'department') {
      if (value) {
        fetchEmployeesInDepartment(value);
      } else {
        setSubstitutions([])
      }
    }
  };

  const handleTouchStart = (e) => {
    const target = e.target;

    if (target.tagName === "SELECT") {
      const clickEvent = new MouseEvent("mousedown", {
        bubbles: true,
        cancelable: true,
        view: window,
      });
      target.dispatchEvent(clickEvent);
    } else if (target.closest(".filepond--root")) {
      const fileInput = target.closest(".filepond--root").querySelector("input[type='file']");
      if (fileInput) {
        fileInput.click();
      }
    }
  };

  const handleBlur = (e) => {
    if (e.target.tagName === "SELECT") {
      e.target.size = 1;
    }
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: checked,
    }));
  };

  const fetchEmployeesInDepartment = async (departmentID) => {
    try {
      let frontendLog = JSON.stringify({ "sessionID": sessionStorage.getItem('sessionID'), "EmployeeID": localStorage.getItem('EmployeeID'), "channel": isMobile ? "Mobile" : "Portal", "language": localStorage.getItem('language') })
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/middleware/getEmployeeInDepartment?code=${process.env.REACT_APP_MIDDLEWARE_FUNCTION_KEY}&DepartmentID=${encodeURIComponent(departmentID)}&token=${encodeURIComponent(localStorage.getItem('id_token'))}&language=${encodeURIComponent(language)}&sessionID=${encodeURIComponent(sessionStorage.getItem('sessionID'))}&frontendLog=${encodeURIComponent(frontendLog)}`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      setSubstitutions(data.data);
      setFormData(prevFormData => ({
        ...prevFormData,
        department: departmentID,
      }));
    } catch (error) {
      console.error('Error fetching employees:', error);
    } finally {
      decrementLoadingCounter()
    }
  };

  const fileTypeMapping = {
    PDF: 'application/pdf',
    JPEG: 'image/jpeg',
    JPG: 'image/jpeg',
    TIF: 'image/tiff',
    TIFF: 'image/tiff',
    GIF: 'image/gif'
  };

  const getMimeTypesString = (fileTypesString) => {
    const fileTypesArray = fileTypesString.split(',');
    const mimeTypesArray = fileTypesArray.map(fileType => fileTypeMapping[fileType.trim()]);
    return mimeTypesArray;
  };

  const updateAttachmentNames = (selectedLeaveType) => {
    if (selectedLeaveType.Attachments) {
      const attachmentNames = selectedLeaveType.Attachments.map(att => att.Attname);
      const attachmentFilesTypes = selectedLeaveType.AttachSupportFileType;
      setAttachmentNames(attachmentNames);
      setAttachmentFilesTypes(getMimeTypesString(attachmentFilesTypes));
    } else {
      setAttachmentNames([]);
      // setAttachmentFilesTypes(getMimeTypesString(defaultFilesAttachments));
    }
  };

  const checkDateDifference = (fromDate, toDate) => {
    const from = new Date(fromDate);
    const to = new Date(toDate);
    const timeDiff = to - from;
    const dayDiff = timeDiff / (1000 * 3600 * 24);
    setNumOfDays(dayDiff + 1 + " " + t('Days')); // Including the start date
    setShowSubstitution(dayDiff > 2); // 4 days or more
  };

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    const updatedFormData = { ...formData, [name]: value };
    setFormData(updatedFormData);
    checkDateDifference(updatedFormData.fromDate, updatedFormData.toDate);
  };

  const validate = () => {
    let tempErrors = {};
    if (!formData.fromDate) tempErrors.fromDate = t("From date is required.");
    if (!formData.toDate) tempErrors.toDate = t("To date is required.");
    if (new Date(formData.fromDate) > new Date(formData.toDate))
      tempErrors.date = t("From date cannot be later than to date.");
    if (attachmentNames.length > 0 && formData.attachments.length !== attachmentNames.length)
      tempErrors.attachments = t("Please upload {{count}} attachment(s).", { count: attachmentNames.length });
    if (formData.leaveType === '0130' && !formData.notes)
      tempErrors.notes = t("Reason is required for this leave type");
    if (!validFiles) {
      tempErrors.attachments = t("Invalid file type. Please upload PDF, JPEG, TIFF, or GIF files.");
    }   // Child Accompany leave
    if (formData.leaveType === '0367' && !selectedChild) {
      tempErrors.child = t("Child is required for this leave type.");
    }  
    // Paternity leave  
    if (formData.leaveType === '0335' && !childBirthDate) {
      tempErrors.childBirthDate = t("Child birth date is required for this leave type.");
    }
    // Accompany patient leave
    if (formData.leaveType === "0260" && !selectedRelativeDegree) {
      tempErrors.relativeDegree = t("Relative degree is required for this leave type.");
    }   

    if (showSubstitution) {
      if (!formData.department) tempErrors.department = t("Department is required for leaves of 4 days or more.");
      if (!formData.employee) tempErrors.employee = t("Substitution is required");
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const formatDate = (date) => {
    const d = new Date(date);
    const isoString = d.toISOString();
    const formatted = isoString.substring(0, 19);
    return formatted;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      setIsLoading(true);
      setResponseMessage(true);
      setIsFormDisabled(true);
      let frontendLog = JSON.stringify({ "sessionID": sessionStorage.getItem('sessionID'), "EmployeeID": localStorage.getItem('EmployeeID'), "channel": isMobile ? "Mobile" : "Portal", "language": localStorage.getItem('language') })
      let calculateLeaveSpanURL = `${process.env.REACT_APP_BACKEND_URL}/middleware/calculateLeaveSpan`;

      const params = {
        code: process.env.REACT_APP_MIDDLEWARE_FUNCTION_KEY,
        EmployeeID: localStorage.getItem('EmployeeID'),
        assertion: localStorage.getItem('id_token'),
        AbsenceTypeCode: formData.leaveType,
        InfoType: "2001",
        StartDate: formatDate(formData.fromDate),
        EndDate: formatDate(formData.toDate),
        InputHours: "0.0m",
        language: language,
        sessionID: sessionStorage.getItem('sessionID'),
        frontendLog: frontendLog
      };

      const searchParams = new URLSearchParams();

      Object.keys(params).forEach(key => {
        if (params[key] !== null && params[key] !== undefined) {
          searchParams.append(key, params[key]);
        }
      });
      if(formData.leaveType == "0367") // Child Accompany leave
      {
        createLeaveRequest();
        return;
      }
      calculateLeaveSpanURL = `${calculateLeaveSpanURL}?${searchParams.toString()}`;

      fetch(calculateLeaveSpanURL, { method: 'GET' })
        .then(response => {
          if (!response.ok) {
            setIsLoading(false);
            if (response.status === 400) {
              return response.json().then(errorData => {
                setIsErrorMessage(true);
                setIsFormDisabled(false);
                setResponseMessage(errorData.error.message.value);
              });
            }
            throw new Error('An error occurred: ' + response.statusText);
          }
          return response.json();
        })
        .then(data => {
          if (data) {
            createLeaveRequest();
          } else {
            setIsErrorMessage(true);
            return Promise.reject('Invalid response code');
          }
        })
        .catch(error => {
          console.error('Error making API request:', error);
          setIsLoading(false);
        });
    }
  };

  const createLeaveRequest = () => {
    let startDate = formatDate(formData.fromDate);
    let endDate = formatDate(formData.toDate);

    const selectedLeaveType = leaveTypes.find(type => type.AbsenceTypeCode === formData.leaveType);
    const leaveName = selectedLeaveType ? selectedLeaveType.AbsenceTypeName : "";

    let frontendLog = JSON.stringify({ "sessionID": sessionStorage.getItem('sessionID'), "EmployeeID": localStorage.getItem('EmployeeID'), "channel": isMobile ? "Mobile" : "Portal", "language": localStorage.getItem('language') })
    const createLeaveRequestEndpoint = `${process.env.REACT_APP_BACKEND_URL}/middleware/createLeaveRequest?code=${process.env.REACT_APP_MIDDLEWARE_FUNCTION_KEY}`;
    const formDataForRequest = new FormData();

    formDataForRequest.append("assertion", localStorage.getItem('id_token'));
    formDataForRequest.append("language", language);
    formDataForRequest.append("x-csrf-token", csrfToken);
    formDataForRequest.append("cookies", cookies);
    formDataForRequest.append("AbsenceTypeCode", formData.leaveType);
    formDataForRequest.append("StartDate", startDate);
    formDataForRequest.append("EndDate", endDate);
    formDataForRequest.append("StartTime", '');
    formDataForRequest.append("EndTime", '');
    formDataForRequest.append("Notes", formData.notes ? formData.notes : "");
    formDataForRequest.append("EmployeeID", localStorage.getItem('EmployeeID'));
    formDataForRequest.append("AbsenceTypeName", leaveName);
    formDataForRequest.append("Seqnr", formData?.approver?.Seqnr);
    formDataForRequest.append("Pernr", formData?.approver?.Pernr);
    formDataForRequest.append("Name", formData?.approver?.Name);
    formDataForRequest.append("sessionID", sessionStorage.getItem('sessionID'));
    formDataForRequest.append("frontendLog", frontendLog);
    // for sick leave
    formDataForRequest.append("hospital_type", formData.hospital_type);
    formDataForRequest.append("hospital_name", formData.hospital_name);
    formDataForRequest.append("hospital_location", formData.hospital_location == "199" ? "X" : "");
       // Child Accompany leave
       if (formData.leaveType === "0367" && selectedChild) {
        formDataForRequest.append("child_id", selectedChild);
      }
      // Paternity leave
      if (formData.leaveType === "0335" && childBirthDate) {
        // ensure YYYYMMDD format
        const formattedBirthDate = new Date(childBirthDate)
          .toISOString()
          .split("T")[0]
          .replace(/-/g, ""); // e.g., 2024-09-02 → 20240902
        formDataForRequest.append("child_birthdate", formattedBirthDate);
      }    
      // Accompany patient leave
      if (formData.leaveType === "0260" && selectedRelativeDegree) {
        formDataForRequest.append("relative_degree", selectedRelativeDegree.RelDegree);
        formDataForRequest.append("relative_degree_text", selectedRelativeDegree.RelDegreeTxt);
      }  
    // patient escorting 
    if (formData.leaveType === "0265") {
      formDataForRequest.append("relative_degree", "ABOVE3");
     } 


    formData.attachments.forEach(file => {
      formDataForRequest.append('attachments', file);
    });

    fetch(createLeaveRequestEndpoint, {
      method: 'POST',
      body: formDataForRequest
    })
      .then(response => {
        if (!response.ok) {
          setIsLoading(false);
          if (response.status === 400) {
            return response.json().then(errorData => {
              setIsErrorMessage(true);
              setIsFormDisabled(false);
              setResponseMessage(errorData.errorData[0]);
            });
          }
          throw new Error('An error occurred: ' + response.statusText);
        }
        return response.json();
      })
      .then(data => {
        const { RequestID, LeaveKey } = data;
        if (showSubstitution) {
          callSubstitutionEndpoint(RequestID, LeaveKey);
        } else {
          sendAttachments(RequestID, LeaveKey);
          notifyChatbot();
        }
      })
      .catch(error => {
        console.error('Error making API request:', error);
        setIsLoading(false);
      });
  };

  const callSubstitutionEndpoint = (RequestID, LeaveKey) => {
    const selectedEmployee = substitutions.find(emp => emp.EmpNum === formData.employee);
    let frontendLog = JSON.stringify({ "sessionID": sessionStorage.getItem('sessionID'), "EmployeeID": localStorage.getItem('EmployeeID'), "channel": isMobile ? "Mobile" : "Portal", "language": localStorage.getItem('language') })
    const substitutionEndpoint = `${process.env.REACT_APP_BACKEND_URL}/middleware/addSubstitution?code=${process.env.REACT_APP_MIDDLEWARE_FUNCTION_KEY}&SubstEmpNum=${selectedEmployee.EmpNum}&SubstituteID=${selectedEmployee.UserID}&BeginDate=${formatDate(formData.fromDate)}&EndDate=${formatDate(formData.toDate)}&UserID=${localStorage.getItem('EmployeeID')}&x-csrf-token=${subCSRFToken}&cookies=${subCookies}&token=${localStorage.getItem('id_token')}&sessionID=${encodeURIComponent(sessionStorage.getItem('sessionID'))}&frontendLog=${encodeURIComponent(frontendLog)}`;

    fetch(substitutionEndpoint, {
      method: 'POST'
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Error creating substitution: ' + response.statusText);
        }
        return response.json();
      })
      .then(async (data) => {
        await sendAttachments(RequestID, LeaveKey);
        notifyChatbot();
      })
      .catch(error => {
        console.error('Error creating substitution:', error);
      });
  };

  const sendAttachments = async (RequestID, LeaveKey) => {
    let frontendLog = JSON.stringify({
      "sessionID": sessionStorage.getItem('sessionID'),
      "EmployeeID": localStorage.getItem('EmployeeID'),
      "channel": isMobile ? "Mobile" : "Portal",
      "language": localStorage.getItem('language')
    });

    const uploadParams = new URLSearchParams({
      "token": localStorage.getItem('id_token'),
      EmployeeID: localStorage.getItem('EmployeeID'),
      RequestID: RequestID,
      LeaveKey: LeaveKey,
      "x-csrf-token": csrfToken,
      "cookies": cookies,
      "sessionID": sessionStorage.getItem('sessionID'),
      "frontendLog": frontendLog
    }).toString();

    // Iterate over each file and send the binary data directly
    for (const file of formData.attachments) {
      const arrayBuffer = await file.arrayBuffer(); // Convert file to binary ArrayBuffer

      const uploadResponse = await fetch(`${process.env.REACT_APP_BACKEND_URL}/middleware/sendAttachments?code=${process.env.REACT_APP_MIDDLEWARE_FUNCTION_KEY}&${uploadParams}`, {
        method: 'POST',
        headers: {
          'Content-Type': file.type, // Set appropriate content type (e.g., image/jpeg, application/pdf)
          'Slug': encodeURIComponent(file.name), // Send the file name in the Slug header
        },
        body: arrayBuffer, // Send binary data as the request body
      });

      if (!uploadResponse.ok) {
        throw new Error('Error uploading attachment: ' + uploadResponse.statusText);
      }

      const uploadData = await uploadResponse.json();
    }
  };

  let frontendLog = { "sessionID": sessionStorage.getItem('sessionID'), "EmployeeID": localStorage.getItem('EmployeeID'), "channel": isMobile ? "Mobile" : "Portal", "language": localStorage.getItem('language') }
  const notifyChatbot = () => {
    const requestData = {
      message: t("leave request saved successfully, you need any help?"),
      user_lang: language,
      session_id: sessionStorage.getItem('sessionID'),
      frontendLog: frontendLog
    };

    fetch(`${process.env.REACT_APP_BACKEND_URL}/chatbot/rephraseMessage?code=${process.env.REACT_APP_CHATBOT_FUNCTION_KEY}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestData)
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        onSendMessage({ sender: 'bot', text: data.message, clearHistory: data.clearHistory });
        sessionStorage.setItem('clearHistory', true)
        setTimeout(() => {
          onSendMessage({
            sender: 'bot',
            isRating: true,
            requestType: data.requestType,
            timestamp: new Date().getTime(),
          });
        }, (process.env.REACT_APP_TIME_TO_DISPLAY_REVIEW * 1000));
        setIsLoading(false);
      })
      .catch(error => {
        console.error('Error making API request:', error);
      });
  };

  const handleCancel = () => {
    setIsLoading(true);
    setResponseMessage(true);
    setIsFormDisabled(true);

    let frontendLog = { "sessionID": sessionStorage.getItem('sessionID'), "EmployeeID": localStorage.getItem('EmployeeID'), "channel": isMobile ? "Mobile" : "Portal", "language": localStorage.getItem('language') }
    const requestData = {
      message: "Leave request cancelled, thank you. Do you need any help?",
      user_lang: language,
      session_id: sessionStorage.getItem('sessionID'),
      frontendLog: frontendLog
    };

    fetch(`${process.env.REACT_APP_BACKEND_URL}/chatbot/rephraseMessage?code=${process.env.REACT_APP_CHATBOT_FUNCTION_KEY}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestData)
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        onSendMessage({ sender: 'bot', text: data.message, clearHistory: data.clearHistory });
        setTimeout(() => {
          onSendMessage({
            sender: 'bot',
            isRating: true,
            requestType: data.requestType,
            timestamp: new Date().getTime(),
          });
        }, (process.env.REACT_APP_TIME_TO_DISPLAY_REVIEW * 1000));
        sessionStorage.setItem('clearHistory', true)
        setIsLoading(false);
      })
      .catch(error => {
        console.error('Error making API request:', error);
      });
  };
  useEffect(() => {
    if (formData.leaveType === "0367") {
      fetchChildDetails();
    }
  }, [formData.leaveType]); // runs on mount and when leaveType changes  
  useEffect(() => {
    if (formData.leaveType === "0260") {
      fetchRelativeDegrees();
    }
  }, [formData.leaveType]); // runs on mount and when leaveType changes  


  return (
    <div className="w-100">
      {isFormLoading ? (
        <div className='centered-v-h'>
          {/* <img src={`${process.env.REACT_APP_PUBLIC_URL}/loading1.gif`} alt="Loading..." className="loading-gif" /> */}
          <img src={loadingGif} alt="Loading..." className="loading-gif" width={50} height={50} />
        </div>
      ) : (
        <>
          <div className="leave-type-select">
              <label className="form-label">{t('Leave Type')}</label>
                <select
                  name="leaveType"
                  value={formData.leaveType}
                  className="form-control small-font"
                  onChange={handleChange}
                  onTouchStart={handleTouchStart}
                  onBlur={handleBlur}
                  disabled={isFormDisabled}
                >
                  {leaveTypes.map((type) => (
                    <option key={type.AbsenceTypeCode} value={type.AbsenceTypeCode}>
                      {type.AbsenceTypeName}
                    </option>
                  ))}
                </select>
              </div>

            
          <div className="form-card">
            <div className="form-card-title">
              {t('When will you be on vacation?')}
            </div>
            <form onSubmit={handleSubmit} className="w-100">
              {isLoading &&
                <div className='centered-v-h loading-overlay'>
                  <img className="img-bottom" src={loadingGif} alt="Loading..." width={70} height={70} />
                  <span className="span-bottom">{t('Processing, please wait ...')}</span>
                </div>
              }
              <div className="mb-3">
                <label className="form-label">{t('From Date')}</label>
                <DateInput
                  name="fromDate"
                  value={formData.fromDate}
                  onChange={handleDateChange}
                  disabled={isFormDisabled}
                  placeholder={t('Select from date')}
                />
                {errors.fromDate && <span className="error">{errors.fromDate}</span>}
              </div>
              <div className="mb-3">
                <label className="form-label">{t('To Date')}</label>
                <DateInput
                  name="toDate"
                  value={formData.toDate}
                  onChange={handleDateChange}
                  disabled={isFormDisabled}
                  placeholder={t('Select to date')}
                />
                {errors.toDate && <span className="error">{errors.toDate}</span>}
              </div>
              <div className="mb-3">
                <label className="form-label">{t('Number of Days')}</label>
                <input
                  type="text"
                  name="numOfDays"
                  className="form-control small-font"
                  value={numOfDays}
                  disabled
                />
              </div>
              {showSubstitution && (
                <div className="flex-row">
                  <div className="inline-form mb-3">
                    <label className="form-label">{t('Substitution')}</label>
                    <div>
                      <select
                        name="department"
                        className="form-control small-font"
                        value={formData.department}
                        onChange={handleChange}
                        onTouchStart={handleTouchStart}
                        onBlur={handleBlur}
                        disabled={isFormDisabled}
                      >
                        <option value="">{t('Select a department')}</option>
                        {departments.map((department) => (
                          <option key={department.Department} value={department.Department}>
                            {department.Name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <select
                        name="employee"
                        className="form-control small-font"
                        value={formData.employee}
                        onChange={handleChange}
                        onTouchStart={handleTouchStart}
                        onBlur={handleBlur}
                        disabled={isFormDisabled}
                      >
                        <option value="">{t('Select an employee')}</option>
                        {substitutions.map((employee) => (
                          <option key={employee.EmpNum} value={employee.EmpNum}>
                            {employee.EmpName}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              )}
              {(formData.leaveType === '0360' || formData.leaveType === '0365') && (
                <>
                  <div className="mb-3">
                    <label className="form-label">{t('Hospital Type')}</label>
                    <select
                      name="hospital_type"
                      value={formData.hospital_type}
                      className="form-control small-font"
                      onChange={handleChange}
                      onTouchStart={handleTouchStart}
                      onBlur={handleBlur}
                      disabled={isFormDisabled}
                    >
                      {hospitalTypes.map((type) => (
                        <option key={type.Field} value={type.Field}>
                          {type.Fieldtxt}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">{t('Hospital Name')}</label>
                    <input
                      type="text"
                      name="hospital_name"
                      className="form-control small-font"
                      value={formData.hospital_name}
                      onChange={handleChange}
                      onTouchStart={handleTouchStart}
                      disabled={isFormDisabled}
                    />
                  </div>
                  <div className="mb-3 form-check">
                    <input
                      type="checkbox"
                      name="hospital_location"
                      className="form-check-input form-control small-font"
                      checked={formData.hospital_location}
                      onChange={handleCheckboxChange}
                      onTouchStart={handleTouchStart}
                      disabled={isFormDisabled}
                    />
                    <label className="">{t('Inside Qatar')}</label>
                  </div>
                </>
              )}
              <div className="mb-3">
                <label className="form-label">{t('Approver')}</label>
                <input
                  type="text"
                  name="approver"
                  className="form-control small-font"
                  value={formData?.approver?.Name}
                  onTouchStart={handleTouchStart}
                  disabled
                />
              </div>
                {/* Child Accompany Leave */}
                {formData.leaveType === "0367" && (
                <div className="mb-3">
                  <label className="form-label">{t('Child')}</label>
                  <select
                    name="child"
                    value={selectedChild}
                    className="form-control small-font"
                    onChange={(e) => setSelectedChild(e.target.value)}
                    onTouchStart={handleTouchStart}
                    onBlur={handleBlur}
                    disabled={isFormDisabled}
                  >
                    <option value="">{t('Select a child')}</option>
                    {childDetails.map((child) => (
                      <option key={child.Zzid} value={child.Zzid}>
                        {child.Zzdesc}
                      </option>
                    ))}
                  </select>
                  {errors.child && <span className="error">{errors.child}</span>}
                </div>
              )}
              {/* Paternity Leave */}
              {formData.leaveType === "0335" && (
                <div className="mb-3">
                  <label className="form-label">{t('Child Birth Date')}</label>
                  <DateInput
                    name="childBirthDate"
                    value={childBirthDate}
                    onChange={(e) => setChildBirthDate(e.target.value)}
                    disabled={isFormDisabled}
                    placeholder={t('Select child birth date')}
                  />
                  {errors.childBirthDate && <span className="error">{errors.childBirthDate}</span>}
                </div>
              )}

                            {/* Accompany Patient Leave */}
                            {formData.leaveType === "0260" && (
                <div className="mb-3">
                  <label className="form-label">{t('Relative Degree')}</label>
                  <select
                    name="relativeDegree"
                    value={selectedRelativeDegree ? selectedRelativeDegree.RelDegree : ""}
                    className="form-control small-font"
                    onChange={(e) => {
                      const degree = relativeDegrees.find(d => d.RelDegree === e.target.value);
                      setSelectedRelativeDegree(degree || null);
                    }}
                    onTouchStart={handleTouchStart}
                    onBlur={handleBlur}
                    disabled={isFormDisabled}
                  >
                  <option value="">{t('Select a relative degree')}</option>
                    {relativeDegrees.map((degree) => (
                      <option key={degree.RelDegree} value={degree.RelDegree}>
                        {degree.RelDegreeTxt}
                      </option>
                    ))}
                    </select>
                  <span className="warning-message">
                    ⚠️ {t('Above 3rd degree relative, please use absence type Patient Escorting (Others)')}
                  </span>
                  {errors.relativeDegree && <span className="error">{errors.relativeDegree}</span>}
                  </div>
              )}
               {/* Patient Escorting (Others) Leave */}
               {formData.leaveType === "0265" && (
                <div className="mb-3">
                  <label className="form-label">{t('Relative Degree')}</label>
                  <input className="form-control" disabled value={t("Above 3rd degree relative")}></input>
                  <span className="warning-message">
                    ⚠️ {t('For degree 1 - 3 degree relative, please use absence type Accompany Patient Leave')}
                  </span>
                  {errors.relativeDegree && <span className="error">{errors.relativeDegree}</span>}
                </div>
              )}

              <div className="mb-3">
                <label className="form-label">{t('Notes')}</label>
                <textarea
                  name="notes"
                  className="form-control small-font"
                  value={formData.notes}
                  onChange={handleChange}
                  onTouchStart={handleTouchStart}
                  disabled={isFormDisabled}
                />
                {errors.notes && <span className="error">{errors.notes}</span>}
              </div>
              {attachmentNames.length > 0 && (
                <div className="mb-3 attachment-container">
                  <label className="mb-2 attachment-name">{t('Attachments Required')}</label>
                  {attachmentNames.map((attachmentName, index) => (
                    <p
                      key={index}
                      type="text"
                      className="form-control small-font small-font"
                      disabled
                    >
                      {attachmentName}
                    </p>
                  ))}
                </div>
              )}
              <div className="mb-3">
                <label className="form-label">{t('Attachments')}</label>
                <FilePond
                  files={formData.attachments}
                  onupdatefiles={handleFilePondUpdate}
                  allowMultiple={true}
                  maxFiles={10}
                  name="attachments"
                  onTouchStart={handleTouchStart}
                  disabled={isFormDisabled}
                  acceptedFileTypes={attachmentFilesTypes}
                  labelIdle={"<span class='large-font'> + </span>" + t('Drag & Drop your files or') + ' <span class="filepond--label-action"> ' + t('Browse') + ' </span>'}
                />
                {errors.attachments && <span className="error">{errors.attachments}</span>}
              </div>
              {responseMessage && <span className={isErrorMessage ? 'red-span' : 'green-span'}>{responseMessage}</span>}
              <div className="substitution-error">
                {errors.employee && <span className="error">{errors.employee}</span>}
              </div>
              <div className="button-group">
                <button className="submit-button" type="submit" disabled={isFormDisabled || isLoading}>
                  {t('Save')}
                </button>
                <button className="cancel-button" type="button" onClick={handleCancel} disabled={isFormDisabled || isLoading}>
                  {t('Cancel')}
                </button>
              </div>
            </form>
          </div>
        </>
      )}
    </div>
  );
}

export default LeaveRequestForm;
